export default "__VITE_ASSET__CmX6iYWc__"